import informationService from '../../src/services/system';
import fciService from '../../src/services/fci';

const searchTrxPropId = (data, field) => {
    let trxPropId = null;

    for (const itemBoxs of data.crud.boxes) {
        for (const item of itemBoxs.fields) {
            if (item.idFieldTable === 'trxPropId') {
                let idField = item.id;
                trxPropId = field[idField].id;
                return trxPropId;
            }
        }
    }
    return trxPropId;
}

const searchCode = async (trxPropId, instance) => {
    return informationService.searchView(`${instance}.argCvFciTrxPropView`).then((response) => {
        for (const itemData of response.data) {
            if (itemData.trxPropId === trxPropId) {
                return itemData.code;
            }
        }
        return null;
    }).catch(error => {
        console.log(error);
        return null;
    });
};

const searchNroId = (data, group, field) => {
    let nroId = null;
    let validate = null;
    data.crud.boxes.forEach((itemBoxs) => {
        itemBoxs.fields.forEach((item) => {
            let idField = item.id;
            switch (item.idFieldTable) {
                case 'idExternal':
                    if (field[idField]) {
                        nroId = field[idField].split(".")[1];
                        validate = field[idField].split(".")[0];
                    }
                    break;
                default:
                    break;
            }
        })
    })

    for (let key in group) {
        for (let r = 0; r < group[key].length; r++) {
            for (let d = 0; d < group[key][r].fields.length; d++) {
                let keyField = group[key][r].fields[d].id;
                let fieldTable = group[key][r].fields[d].idFieldTable;
                switch (fieldTable) {
                    case 'idExternal':
                        if (field[keyField]) {
                            nroId = field[keyField].split(".")[1];
                            validate = field[keyField].split(".")[0];
                        }
                        break;
                    default:
                        break;
                }
            }
        }
    }
    if (validate === 'rescates' || validate === 'fondos') {
        return nroId;
    }
    return null;
}

const generateRequest = (response, data, group, field, instance, uriParameter) => {

    let id = response.id;
    let uri = response.uri;
    let cantidadCuotaPartes = response.cantidadCuotaPartes;
    let estado = response.estado;
    let monto = response.monto;
    let liquidaEnBYMA = response.liquidaEnBYMA;
    let fechaAlta = response.fechaAlta;
    let idOrigen = response.idOrigen;
    let origen = response.origen;
    let price = response.price;
    let numeroPedido = response.numeroPedido;
    let comitente = response.comitente;

    let arrayRequest = [];
    data.crud.boxes.forEach((itemBoxs) => {
        itemBoxs.fields.forEach((item) => {
            for (let key in field) {
                if (key === item.id && item.group == null) {
                    let existe = false;
                    let value = field[key];

                    if (item.table === 'trx' || item.table === 'trxLine') {
                        for (let r = 0; r < arrayRequest.length; r++) {
                            if (arrayRequest[r].table === `${instance}.${item.table}`) {
                                if (item.idFieldTable === 'id') {
                                    if (field[key] !== null) {
                                        value = value.toString().replace(/\./g, '');
                                        value = value.toString().replace(/,/g, '');
                                        arrayRequest[r].fields.push({ id: item.idFieldTable, value: value })
                                    }
                                } else {
                                    switch (item.idFieldTable) {
                                        case 'idExternal':
                                            if (field[key] !== `${uri}.${id}`)
                                                arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${uri}.${id}'` })
                                            break;
                                        case 'companyId':
                                            if (field[key].id !== "1")
                                                arrayRequest[r].fields.push({ id: item.idFieldTable, value: "1" })
                                            break;
                                        case 'qty':
                                            if (cantidadCuotaPartes !== undefined) {
                                                let oldValueQty = field[key].replace(/\./g, '');
                                                oldValueQty = oldValueQty.replace(/,/g, '.');
                                                if (Number(oldValueQty) !== Number(cantidadCuotaPartes))
                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: cantidadCuotaPartes })
                                            }
                                            break;
                                        case 'status':
                                            if (estado !== undefined) {
                                                if (field[key] !== estado)
                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${estado}'` })
                                            }
                                            break;
                                        case 'isInactive':
                                            if (estado !== undefined) {
                                                if (estado === 'Rechazado' || estado === 'Anulado')
                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: '1' })
                                            }
                                            break;
                                        case 'amount':
                                            if (monto !== undefined) {
                                                let oldValueAmount = field[key].replace(/\./g, '');
                                                oldValueAmount = oldValueAmount.replace(/,/g, '.');
                                                if (Number(oldValueAmount) !== Number(monto))
                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: monto })
                                            }
                                            break;
                                        case 'isBymaClearing':
                                            if (liquidaEnBYMA !== undefined) {
                                                if (liquidaEnBYMA === false)
                                                    liquidaEnBYMA = "0"
                                                else
                                                    liquidaEnBYMA = "1"
                                                if (field[key] !== liquidaEnBYMA)
                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: liquidaEnBYMA })
                                            }
                                            break;
                                        case 'date':
                                            if (fechaAlta !== undefined) {
                                                if (field[key] !== fechaAlta.split('T')[0])
                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${fechaAlta.split('T')[0]}'` })
                                            }
                                            break;
                                        case 'time':
                                            if (fechaAlta !== undefined) {
                                                if (field[key] !== fechaAlta.split('T')[1].substring(0, 7))
                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${fechaAlta.split('T')[1].substring(0, 7)}'` })
                                            }
                                            break;
                                        case 'name':
                                            if (idOrigen !== undefined) {
                                                if (field[key] !== idOrigen)
                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${idOrigen}'` })
                                            }
                                            break;
                                        case 'nameAlt':
                                            if (numeroPedido !== undefined) {
                                                if (field[key].toString() !== numeroPedido.toString())
                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${numeroPedido}'` })
                                            }
                                            break;
                                        case 'source':
                                            if (origen !== undefined) {
                                                if (field[key] !== origen)
                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${origen}'` })
                                            }
                                            break;
                                        case 'price':
                                            if (price !== undefined && uriParameter !== 'rescates') {
                                                let oldValuePrice = field[key].replace(/\./g, '');
                                                oldValuePrice = oldValuePrice.replace(/,/g, '.');

                                                if (Number(oldValuePrice) !== Number(price))
                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: price })
                                            }
                                            break;
                                        case 'entityPropertyId':
                                            if (comitente !== undefined) {
                                                if (field[key].id !== comitente)
                                                    arrayRequest[r].fields.push({ id: item.idFieldTable, value: `'${comitente}'` })
                                            }
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                existe = true;
                            }
                        }
                        if (existe === false) {

                            if (item.idFieldTable === 'id') {
                                if (field[key] !== null) {
                                    value = value.toString().replace(/\./g, '');
                                    value = value.toString().replace(/,/g, '');
                                    arrayRequest.push({
                                        table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: value }]
                                    })
                                }
                            } else {
                                switch (item.idFieldTable) {
                                    case 'idExternal':
                                        if (field[key] !== `${uri}.${id}`)
                                            arrayRequest.push({
                                                table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${uri}.${id}'` }]
                                            })
                                        break;
                                    case 'companyId':
                                        if (field[key].id !== "1")
                                            arrayRequest.push({
                                                table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: "1" }]
                                            })
                                        break;
                                    case 'qty':
                                        if (cantidadCuotaPartes !== undefined) {
                                            let oldValueQty = field[key].replace(/\./g, '');
                                            oldValueQty = oldValueQty.replace(/,/g, '.');
                                            if (Number(oldValueQty) !== Number(cantidadCuotaPartes))
                                                arrayRequest.push({
                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: cantidadCuotaPartes }]
                                                })
                                        }
                                        break;
                                    case 'status':
                                        if (estado !== undefined) {
                                            if (field[key] !== estado)
                                                arrayRequest.push({
                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${estado}'` }]
                                                })
                                        }
                                        break;
                                    case 'isInactive':
                                        if (estado !== undefined) {
                                            if (estado === 'Rechazado' || estado === 'Anulado')
                                                arrayRequest.push({
                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: '1' }]
                                                })
                                        }
                                        break;
                                    case 'amount':
                                        if (monto !== undefined) {
                                            let oldValueAmount = field[key].replace(/\./g, '');
                                            oldValueAmount = oldValueAmount.replace(/,/g, '.');

                                            if (Number(oldValueAmount) !== Number(monto))
                                                arrayRequest.push({
                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: monto }]
                                                })
                                        }
                                        break;
                                    case 'isBymaClearing':
                                        if (liquidaEnBYMA !== undefined) {
                                            if (liquidaEnBYMA === false)
                                                liquidaEnBYMA = "0"
                                            else
                                                liquidaEnBYMA = "1"
                                            if (field[key] !== liquidaEnBYMA)
                                                arrayRequest.push({
                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: liquidaEnBYMA }]
                                                })
                                        }
                                        break;
                                    case 'date':
                                        if (fechaAlta !== undefined) {
                                            if (field[key] !== fechaAlta.split('T')[0])
                                                arrayRequest.push({
                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${fechaAlta.split('T')[0]}'` }]
                                                })
                                        }
                                        break;
                                    case 'time':
                                        if (fechaAlta !== undefined) {
                                            if (field[key] !== fechaAlta.split('T')[1].substring(0, 7)[0])
                                                arrayRequest.push({
                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${fechaAlta.split('T')[1].substring(0, 7)[0]}'` }]
                                                })
                                        }
                                        break;
                                    case 'name':
                                        if (idOrigen !== undefined) {
                                            if (field[key] !== idOrigen)
                                                arrayRequest.push({
                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${idOrigen}'` }]
                                                })
                                        }
                                        break;
                                    case 'nameAlt':
                                        if (numeroPedido !== undefined) {
                                            if (field[key].toString() !== numeroPedido.toString())
                                                arrayRequest.push({
                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${numeroPedido}'` }]
                                                })
                                        }
                                        break;
                                    case 'source':
                                        if (origen !== undefined) {
                                            if (field[key] !== origen)
                                                arrayRequest.push({
                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${origen}'` }]
                                                })
                                        }
                                        break;
                                    case 'price':
                                        if (price !== undefined && uriParameter !== 'rescates') {
                                            let oldValuePrice = field[key].replace(/\./g, '');
                                            oldValuePrice = oldValuePrice.replace(/,/g, '.');

                                            if (Number(oldValuePrice) !== Number(price))
                                                arrayRequest.push({
                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: price }]
                                                })
                                        }
                                        break;
                                    case 'entityPropertyId':
                                        if (comitente !== undefined) {
                                            if (field[key].id !== comitente)
                                                arrayRequest.push({
                                                    table: `${instance}.${item.table}`, fields: [{ id: item.idFieldTable, value: `'${comitente}'` }]
                                                })
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    }
                }
            }
        })
    })

    let groupFlag = JSON.parse(JSON.stringify(group));
    for (let key in groupFlag) {
        let arrayFlag = [];
        for (let f = 0; f < groupFlag[key].length; f++) {
            if (f !== groupFlag[key].length - 1)
                arrayFlag.push(groupFlag[key][f]);
        }
        groupFlag[key] = arrayFlag;
    }
    for (let key in groupFlag) {
        for (let r = 0; r < groupFlag[key].length; r++) {
            let table;
            let fields = [];
            for (let d = 0; d < groupFlag[key][r].fields.length; d++) {
                let keyField = groupFlag[key][r].fields[d].id;
                let fieldTable = groupFlag[key][r].fields[d].idFieldTable;
                if (groupFlag[key][r].fields[d].table === 'trx' || groupFlag[key][r].fields[d].table === 'trxLine') {
                    if (field[keyField] != null && fieldTable !== null) {
                        if (groupFlag[key][r].fields[d].idFieldTable === 'id') {
                            let valueGroup = field[keyField];
                            valueGroup = valueGroup.toString().replace(/\./g, '');
                            valueGroup = valueGroup.toString().replace(/,/g, '');
                            fields.push({ id: fieldTable, value: valueGroup })
                        } else {
                            switch (fieldTable) {
                                case 'idExternal':
                                    if (field[keyField] !== `${uri}.${id}`)
                                        fields.push({ id: fieldTable, value: `'${uri}.${id}'` })
                                    break;
                                case 'companyId':
                                    if (field[keyField].id !== "1")
                                        fields.push({ id: fieldTable, value: "1" })
                                    break;
                                case 'qty':
                                    if (cantidadCuotaPartes !== undefined) {
                                        let oldValueQty = field[keyField].replace(/\./g, '');
                                        oldValueQty = oldValueQty.replace(/,/g, '.');

                                        if (Number(oldValueQty) !== Number(cantidadCuotaPartes))
                                            fields.push({ id: fieldTable, value: cantidadCuotaPartes })
                                    }
                                    break;
                                case 'status':
                                    if (estado !== undefined) {
                                        if (field[keyField] !== estado)
                                            fields.push({ id: fieldTable, value: `'${estado}'` })
                                    }
                                    break;
                                case 'isInactive':
                                    if (estado !== undefined) {
                                        if (estado === 'Rechazado' || estado === 'Anulado')
                                            fields.push({ id: fieldTable, value: '1' })
                                    }
                                    break;
                                case 'amount':
                                    if (monto !== undefined) {
                                        let oldValueAmount = field[keyField].replace(/\./g, '');
                                        oldValueAmount = oldValueAmount.replace(/,/g, '.');
                                        if (Number(oldValueAmount) !== Number(monto))
                                            fields.push({ id: fieldTable, value: monto })
                                    }
                                    break;
                                case 'isBymaClearing':
                                    if (liquidaEnBYMA !== undefined) {
                                        if (liquidaEnBYMA === false)
                                            liquidaEnBYMA = "0"
                                        else
                                            liquidaEnBYMA = "1"
                                        if (field[keyField] !== liquidaEnBYMA)
                                            fields.push({ id: fieldTable, value: liquidaEnBYMA })
                                    }
                                    break;
                                case 'date':
                                    if (fechaAlta !== undefined) {
                                        if (field[keyField] !== fechaAlta.split('T')[0])
                                            fields.push({ id: fieldTable, value: `'${fechaAlta.split('T')[0]}'` })
                                    }
                                    break;
                                case 'time':
                                    if (fechaAlta !== undefined) {
                                        if (field[keyField] !== fechaAlta.split('T')[1].substring(0, 7))
                                            fields.push({ id: fieldTable, value: `'${fechaAlta.split('T')[1].substring(0, 7)}'` })
                                    }
                                    break;
                                case 'name':
                                    if (idOrigen !== undefined) {
                                        if (field[keyField] !== idOrigen)
                                            fields.push({ id: fieldTable, value: `'${idOrigen}'` })
                                    }
                                    break;
                                case 'nameAlt':
                                    if (numeroPedido !== undefined) {
                                        if (field[keyField].toString() !== numeroPedido.toString())
                                            fields.push({ id: fieldTable, value: `'${numeroPedido}'` })
                                    }
                                    break;
                                case 'source':
                                    if (origen !== undefined) {
                                        if (field[keyField] !== origen)
                                            fields.push({ id: fieldTable, value: `'${origen}'` })
                                    }
                                    break;
                                case 'price':
                                    if (price !== undefined && uriParameter !== 'rescates') {
                                        let oldValuePrice = field[key].replace(/\./g, '');
                                        oldValuePrice = oldValuePrice.replace(/,/g, '.');
                                        if (Number(oldValuePrice) !== Number(price))
                                            fields.push({ id: fieldTable, value: price })
                                    }
                                    break;
                                case 'entityPropertyId':
                                    if (comitente !== undefined) {
                                        if (field[keyField].id !== comitente)
                                            fields.push({ id: fieldTable, value: `'${comitente}'` })
                                    }
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                }
            }
            data.crud.boxes.forEach((itemBoxs) => {
                itemBoxs.fields.forEach((item) => {
                    if (item.group !== null) {
                        item.group.forEach((itemGroup) => {
                            itemGroup.fields.forEach((itemGroupFields) => {
                                if (itemGroup.name === key) {
                                    table = itemGroupFields.table;
                                }
                            })
                        })
                    }
                })
            })
            arrayRequest.push({
                table: `${instance}.${table}`, fields: fields
            })
        }
    }
    return arrayRequest;
}

const generateAuditIntegration = (arraySave, data, group, field, id, user) => {
    let arrayAudit = [];
    for (const itemTable of arraySave) {
        for (const itemFields of itemTable.fields) {
            if (itemFields.id !== 'id') {
                data.crud.boxes.forEach((itemBoxs) => {
                    itemBoxs.fields.forEach((item) => {
                        if (item.table === 'trx' || item.table === 'trxLine') {
                            if (item.idFieldTable === itemFields.id) {
                                let idField = item.id;
                                let isDifferent = false;
                                if (item.type === 'Currency' || item.type.includes('Number')) {
                                    let oldValue = field[idField];
                                    oldValue = oldValue.replace(/\./g, '');
                                    oldValue = oldValue.replace(/,/g, '.');

                                    if (Number(oldValue) !== Number(itemFields.value)) {
                                        isDifferent = true;
                                    }
                                } else {
                                    if (item.type === 'Select') {
                                        if (field[idField].id !== itemFields.value) {
                                            isDifferent = true;
                                        }
                                    } else {
                                        if (field[idField] !== itemFields.value) {
                                            isDifferent = true;
                                        }
                                    }
                                }

                                if (isDifferent) {
                                    let oldValue = field[idField];
                                    if (typeof field[idField] === 'object')
                                        oldValue = field[idField].id;

                                    arrayAudit.push({
                                        context: 'Integración',
                                        doc: data.id,
                                        fieldId: idField,
                                        field: item.name,
                                        id,
                                        mode: 'U',
                                        newValue: itemFields.value,
                                        oldValue,
                                        user: user.email
                                    })
                                }
                            }
                        }
                    })
                })

                for (let key in group) {
                    for (let r = 0; r < group[key].length; r++) {
                        for (let d = 0; d < group[key][r].fields.length; d++) {
                            let keyField = group[key][r].fields[d].id;
                            if (group[key][r].fields[d].table === 'trx' || group[key][r].fields[d].table === 'trxLine') {
                                if (keyField === itemFields.id) {
                                    let idField = keyField;
                                    let isDifferent = false;
                                    if (group[key][r].fields[d].type === 'Currency' || group[key][r].fields[d].type.includes('Number')) {
                                        let oldValue = field[idField];
                                        oldValue = oldValue.replace(/\./g, '');
                                        oldValue = oldValue.replace(/,/g, '.');

                                        if (Number(oldValue) !== Number(itemFields.value)) {
                                            isDifferent = true;
                                        }
                                    } else {
                                        if (group[key][r].fields[d].type === 'Select') {
                                            if (field[idField].id !== itemFields.value) {
                                                isDifferent = true;
                                            }
                                        } else {
                                            if (field[idField] !== itemFields.value) {
                                                isDifferent = true;
                                            }
                                        }
                                    }

                                    if (isDifferent) {
                                        let oldValue = field[idField];
                                        if (typeof field[idField] === 'object')
                                            oldValue = field[idField].id;

                                        arrayAudit.push({
                                            context: 'Integración',
                                            doc: data.id,
                                            fieldId: idField,
                                            field: group[key][r].fields[d].name,
                                            id,
                                            mode: 'U',
                                            newValue: itemFields.value,
                                            oldValue,
                                            user: user.email
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return arrayAudit;
}

const fciAlta = async (data, field, group, client, instance) => {
    let trxPropId = searchTrxPropId(data, field);
    let uri = await searchCode(trxPropId, instance);
    let request = {};
    let requestComitente = {};
    let currencyId;
    let itemPropertyId;
    let depositoryId;
    data.crud.boxes.forEach((itemBoxs) => {
        itemBoxs.fields.forEach((item) => {
            let idField = item.id;
            switch (item.idFieldTable) {
                case 'depositoryId':
                    depositoryId = field[idField].id;
                    break;
                case 'itemPropertyId':
                    itemPropertyId = field[idField].id;
                    break;
                case 'currencyId':
                    currencyId = field[idField].id;
                    break;
                case 'qty':
                    let fieldQty = field[idField];
                    fieldQty = fieldQty.replace(/\./g, '');
                    fieldQty = fieldQty.replace(/,/g, '.');
                    request.cantidadCuotaPartes = Number(fieldQty);
                    requestComitente.cantidad = Number(fieldQty);
                    break;
                case 'amount':
                    let fieldAmount = field[idField];
                    fieldAmount = fieldAmount.replace(/\./g, '');
                    fieldAmount = fieldAmount.replace(/,/g, '.');
                    request.monto = Number(fieldAmount);
                    break;
                case 'isBymaClearing':
                    request.liquidaEnBYMA = field[idField];
                    break;
                case 'name':
                    request.idOrigen = field[idField];
                    break;
                case 'dueDate':
                    request.fechaLiquidacion = field[idField];
                    break;
                case 'redemptionTypeId':
                    request.tipoRescate = field[idField];
                    if (!field[idField]) {
                        request.tipoRescate = 'MONTO';
                    }
                    break;
                case 'entityPropertyId':
                    requestComitente.comitente = field[idField].id;
                    break;
                default:
                    break;
            }
        })
    })

    for (let key in group) {
        for (let r = 0; r < group[key].length; r++) {
            for (let d = 0; d < group[key][r].fields.length; d++) {
                let keyField = group[key][r].fields[d].id;
                let fieldTable = group[key][r].fields[d].idFieldTable;
                switch (fieldTable) {
                    case 'depositoryId':
                        depositoryId = field[keyField].id;
                        break;
                    case 'itemPropertyId':
                        itemPropertyId = field[keyField].id;
                        break;
                    case 'currencyId':
                        currencyId = field[keyField].id;
                        break;
                    case 'qty':
                        let fieldQty = field[keyField];
                        fieldQty = fieldQty.replace(/\./g, '');
                        fieldQty = fieldQty.replace(/,/g, '.');
                        request.cantidadCuotaPartes = Number(fieldQty);
                        requestComitente.cantidad = Number(fieldQty);
                        break;
                    case 'amount':
                        let fieldAmount = field[keyField];
                        fieldAmount = fieldAmount.replace(/\./g, '');
                        fieldAmount = fieldAmount.replace(/,/g, '.');
                        request.monto = Number(fieldAmount);
                        break;
                    case 'isBymaClearing':
                        request.liquidaEnBYMA = field[keyField];
                        break;
                    case 'name':
                        request.idOrigen = field[keyField];
                        break;
                    case 'dueDate':
                        request.fechaLiquidacion = field[keyField];
                        break;
                    case 'redemptionTypeId':
                        request.tipoRescate = field[keyField];
                        if (!field[keyField]) {
                            request.tipoRescate = 'MONTO';
                        }
                        break;
                    case 'entityPropertyId':
                        requestComitente.comitente = field[keyField].id;
                        break;
                    default:
                        break;
                }
            }
        }
    }


    try {
        const response = await fciService.fciAlta(client, instance, uri, currencyId, itemPropertyId, depositoryId, request);
        let responseService = response.data;

        if (responseService.errores) {
            return responseService;
        } else {
            requestComitente.comitente = responseService.emisor.codigo;
            responseService.uri = uri;
            responseService.moneda = currencyId;
            responseService.especie = itemPropertyId;
            responseService.emisor.codigo = depositoryId;

            if (uri === 'rescates') {
                let nroId = responseService.id;

                await fciService.fciAltaComitente(client, instance, uri, nroId, requestComitente);
                const responseComitente = await fciService.fciAltaComitente(client, instance, uri, nroId, requestComitente);
                const responseServiceComitente = responseComitente.data;
                const combinedObject = { ...responseService, ...responseServiceComitente };
                return generateRequest(combinedObject, data, group, field, instance);
            } else {
                return generateRequest(responseService, data, group, field, instance);
            }

        }
    } catch (error) {
        return undefined; // Maneja el error y retorna undefined
    }
}

const fciConsulta = async (data, field, group, client, instance, id) => {

    let trxPropId = searchTrxPropId(data, field);
    let uri = await searchCode(trxPropId, instance);
    let nroId = searchNroId(data, group, field);

    if (nroId) {
        const response = await fciService.fciConsulta(client, instance, uri, nroId);
        let responseService = response.data;
        if (responseService.errores) {
            return responseService;
        } else {
            responseService.uri = uri;
            let arrayRequest = generateRequest(responseService, data, group, field, instance);
            return arrayRequest;
        }
    } else
        return null;
}

const generateComitentes = async (data, field, group, client, instance) => {

    let trxPropId = searchTrxPropId(data, field);
    let uri = await searchCode(trxPropId, instance);
    let nroId = searchNroId(data, group, field);
    if (uri === 'rescates' && nroId) {
        let responseComitente = await fciService.fciConsultaComitente(client, instance, uri, nroId);
        const responseServiceComitente = responseComitente.data;
        let cantidad = responseServiceComitente.cantidad;
        if (Number(cantidad) > 1) {

        }
    }
}

const fciIngresar = async (data, field, group, client, instance, id) => {

    let trxPropId = searchTrxPropId(data, field);
    let uri = await searchCode(trxPropId, instance);
    let nroId = searchNroId(data, group, field);
    if (nroId) {
        try {
            const response = await fciService.fciIngresar(client, instance, uri, nroId);
            let responseService = response.data;
            if (responseService.errores) {
                return responseService;
            }
            return "ok";
        } catch (error) {
            console.log(error);
        }
    }
    return null;
}

const fciEliminar = async (data, field, group, client, instance) => {

    let trxPropId = searchTrxPropId(data, field);
    let uri = await searchCode(trxPropId, instance);
    let nroId = searchNroId(data, group, field);
    if (nroId) {
        try {
            const response = await fciService.fciEliminar(client, instance, uri, nroId);
            let responseService = response.data;
            if (responseService.errores) {
                return responseService;
            }
            return "ok";
        } catch (error) {
            console.log(error);
        }
    }
    return null;
}

const fciAnular = async (data, field, group, client, instance) => {

    let trxPropId = searchTrxPropId(data, field);
    let uri = await searchCode(trxPropId, instance);
    let nroId = searchNroId(data, group, field);
    if (nroId) {
        try {
            const response = await fciService.fciAnular(client, instance, uri, nroId);
            let responseService = response.data;
            if (responseService.errores) {
                return responseService;
            }
            return "ok";
        } catch (error) {
            console.log(error);
        }
    }
    return null;
}

const fciFunctions = {
    fciAlta,
    fciIngresar,
    fciConsulta,
    fciEliminar,
    fciAnular,
    generateAuditIntegration,
    generateComitentes
}

export default fciFunctions;